import React, { useState, useCallback, useMemo, JSX } from 'react';
import { MainContext } from '../MainContext';

interface MainContextProviderProps {
	children: React.ReactNode;
}

export const MainContextProvider = ({ children }: MainContextProviderProps) => {
	const [pageTitle, setPageTitle] = useState<JSX.Element>(<></>);

	const setTitleFunc = useCallback((title: JSX.Element) => {
		setPageTitle(title);
	}, []);

	const contextValue = useMemo(
		() => ({
			pageTitle,
			setTitle: setTitleFunc
		}),
		[pageTitle]
	);

	return (
		<MainContext.Provider value={contextValue}>{children}</MainContext.Provider>
	);
};
